import styled from 'styled-components';
import {grid} from '../../utils/styled/_grid.style';
import {colors} from '../../utils/styled/_variables.styled';

export const InfiosThankYouMessage = styled.section`
    ${grid};
    display: flex;
    position: fixed;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    width: 100vw;
    padding: 80px 96px;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    background-color: ${colors.gray1};
    z-index: 300;

    & > * {
        margin: 0;
    }

    svg {
        height: 33px;
        width: 33px;
        margin-right: 23px;
        margin-top: 3px;
    }

    .content-wrapper {
        display: flex;
        flex-direction: column;

        .text {
            margin-top: 16px;
        }
    }
`;
